module.exports = ".services-one .service-sec {\n  width: 100%; }\n\n.wpb_single_image {\n  margin: 0 15px 0 0 !important;\n  padding: 0 15px 0 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = 111
// module chunks = 1